/**
 * Функция достижения целей в Яндекс.Метрике
 */
'use strict';

export default function YandexReachGoal(counterId, goalName, verbose = false) {
    if(verbose){
        console.log('YandexReachGoal: counterId = ' + counterId + ', goalName = ' + goalName);
    }

    var counterName = 'yaCounter' + counterId;

    if(!checkCounter()){
        waitCounter();
    }

    function waitCounter(){
        var count = 0;
        var timerId = setInterval(function() {
            count++;
            if((checkCounter()) || (count > 2)){
                clearInterval(timerId);
            }
        }, 1000);
    }

    function checkCounter(){
        var counter = window[counterName];
        if (typeof counter !== 'undefined') {
            reachGoal(counter);
            return true;
        }
        return false;
    }

    function reachGoal(counter){
        if(verbose) {
            console.log('Reached goal: ' + goalName);
        }
        counter.reachGoal(goalName);
    }
}


